import * as React from 'react';
import { Columns, Column } from 'src/components/Layout/Grid';
import Wrapper from 'src/components/Wrapper';
import MyPageInfo from '../MyPage/myPageInfo.component';
import ActivityThemes from '../ActivityTheme/';
import { connect } from 'react-redux';
import { ActivitySelector } from 'src/Entities/Activity/Activity.Selector';
import { Dispatch } from 'redux';
import { Action } from 'redux-actions';
import SearchComponent from '../SeachPage/Seach.component';
import { ActivityCategorySelector } from 'src/Entities/ActivityCategory/ActivityCategory.Selector';
import { setSlecetedActivtyAction } from 'src/Entities/PortalState/PortalState.Actions';
import { Redirect } from 'react-router';
import CourseCarousel, {
  ICourseCarouselItem
} from 'src/components/CourseCarousel';
import NewsTickerContainer from 'src/components/News/NewsTicker/NewsTickerContainer';
import CourseIndex from './CourseIndex.component';

interface IProps {
  sliderActivities: ICourseCarouselItem[];
  showIntrests: boolean;
  setSelectedActivity: (
    detailkursusId: string,
    themeId: string,
    categoryId: string
  ) => void;
}

interface IState {
  shouldRedirect: boolean;
}

class CoursePortalHomePage extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { shouldRedirect: false };
    this.onActivitySelect = this.onActivitySelect.bind(this);
  }

  public onActivitySelect(detailkursusId: string) {
    const act = ActivitySelector.getActivityById(detailkursusId);
    const themeId = ActivityCategorySelector.getCategoryById(
      act.categoryId.toString()
    ).themeId.toString();
    this.props.setSelectedActivity(
      act.detailKursusId.toString(),
      themeId,
      act.categoryId.toString()
    );
    this.setState({ shouldRedirect: true });
  }
  public render() {
    return (
      <div className="pt-10">
        <Wrapper className="pb-12">
          <CourseCarousel
            className="h-100"
            onActivitySelect={this.onActivitySelect}
            courses={this.props.sliderActivities}
          />
          <NewsTickerContainer />
        </Wrapper>
        <div className="has-background-gray-body py-12">
          {this.state.shouldRedirect ? (
            <Redirect to="/kursus/" push={true} />
          ) : null}

          <Wrapper>
            <div className="has-background-white pr-14 mt-12">
              <SearchComponent
                className="-mt-6"
                style={{ transform: 'translateY(-1.5rem)' }}
              />
              <div className="py-11 pl-11 -mt-6">
                <CourseIndex />
              </div>
            </div>
          </Wrapper>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  sliderActivities: ActivitySelector.getActivtiesForSlider()
});

const mapDispatchToProps = (dispatch: Dispatch<Action<any>>) => ({
  setSelectedActivity: (
    detailKursusid: string,
    themeId: string,
    categoryId: string
  ) => dispatch(setSlecetedActivtyAction(detailKursusid, themeId, categoryId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CoursePortalHomePage);



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Home/index.tsx